import { MailOutlined } from "@ant-design/icons";
import { Form, Input } from "antd";
import React from "react";

const FormEmail = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="email"
      rules={[
        {
          required: true,
          message: "Vui lòng nhập email",
        },
        {
          whitespace: true,
          message: "Email không xác định",
        },
        {
          type: "email",
          message: "Không phải định dạng email",
        },
      ]}
    >
      <Input
        prefix={<MailOutlined className="form-item-icon" />}
        placeholder="Email"
        disabled={disabled}
        className="min-h-[40px] bg-transparent"
      />
    </Form.Item>
  );
};

export default FormEmail;
